


























































































































































import { Component, Mixins, Prop } from 'vue-property-decorator';
import PasswordComponent from '../../../../commoncomponents/passwordcomponent/PasswordComponent.vue';
import applicationStore from '@/store/modules/applications/applicationStore';
import commonEntryStore from '@/store/modules/commonEntry';
import passwordStore from '@/store/modules/password';
import { ScreenText } from '@/lang/ScreenText';
import { PassObj, RegisterObj, TypeObj } from '@/Model/model';
import APP_CONST from '@/constants/AppConst';
import APP_UTILITIES from '@/utilities/commonFunctions';
import config from '@/config';
import UIkit from 'uikit';
import AccountSettings from '@/mixins/accountSettings.mixin';
import StripeModule from '@/store/modules/stripe/module';
import { getInstance } from '@/auth';
import Spinner from '@/commoncomponents/spinner/Spinner.vue';

@Component({
  components: {
    Spinner,
    'password-component': PasswordComponent,
  },
})
export default class SignUp extends Mixins(AccountSettings) {
  @Prop({ type: String, default: APP_CONST.APP_ROUTES.DASHBOARD.path })
  readonly redirect!: string;
  private objScreenText: ScreenText = new ScreenText();
  private tooltipDisplay: boolean = false;
  public readonly APP_ROUTES = APP_CONST.APP_ROUTES;
  public styleClass: string = '';
  public strMessage: string = '';
  public typeobj: PassObj = config.registerPassObj;
  public setPasswordPath: string = APP_CONST.SET_PASSWORD;
  public pathName: string | undefined = '';
  public showSetPasswordPage: boolean = false;
  public hovering: boolean = false;
  public hoverText: string = '';
  public hoverStyleObj: any = {};
  public loginProcessing: boolean = false;
  public passValidation: any = {
    oldPassword: -1,
    password: -1,
    confirmPassword: -1,
  };
  public rememberMeFlag: any = -1;
  public privacyPolicyFlag: any = -1;
  public errorMessage: boolean = false;
  private firstErrorForAdmin: boolean = true;
  public refSource: any = 'web';
  APP_CONST = APP_CONST;

  created() {
    APP_UTILITIES.segmentTrackEvent(APP_CONST.SEGMENT_EVENTS.SIGN_UP.viewedSignUp);
  }

  public getScreenText(key: string): string {
    return this.objScreenText.getScreenText(key);
  }
  public errorEmailNotFound: boolean = false;

  /* istanbul ignore next */
  get firstName(): string {
    return commonEntryStore.userFirstName;
  }

  /* istanbul ignore next */
  get applicationData() {
    return applicationStore.applicationDataInfo;
  }

  /* istanbul ignore next */
  get email(): string {
    return commonEntryStore.getEmail;
  }

  /* istanbul ignore next */
  get rememberMe(): boolean {
    return commonEntryStore.getRememberMe;
  }

  get privacyPolicyChecked(): boolean {
    return commonEntryStore.getPrivacyPolicyChecked;
  }

  /* istanbul ignore next */
  get tokenValidity(): string {
    return commonEntryStore.tokenValidity;
  }

  /* istanbul ignore next */
  set email(email: string) {
    commonEntryStore.setEmail(email);
  }

  get disableSubmit(): boolean {
    let result = false;
    if (
      this.loginProcessing ||
      !this.rememberMe || // This is used for the ToS box :\
      !this.privacyPolicyChecked ||
      passwordStore.getPassword !== passwordStore.getConfirmPassword
    ) {
      result = true;
    }
    return result;
  }

  onClick() {
    this.$gtm.trackEvent({
      event: null,
      category: 'Register Page',
      action: 'click',
      label: 'Register Page Click Event Activated',
      value: 5000,
      noninteraction: false,
    });
  }

  /* istanbul ignore next */
  mounted() {
    if (this.$route && !this.$route.query.ref_source) {
      this.refSource = 'web';
    }
    else {
      this.refSource = this.$route && this.$route.query.ref_source;
    }

    if (this.$route !== undefined && this.$gtm !== undefined) {
      this.$gtm.trackView(this.$route && this.$route.name, this.$route.path);
    }
  }

  public clickRemember(): void {
    const checked = this.rememberMe
      ? false
      : true;
    commonEntryStore.setRememberMe({
      checked: checked,
      type: this.typeobj.type,
    });
    this.rememberMeFlag = true;
  }

  public clickPrivacyPolicy(): void {
    const checked = this.privacyPolicyChecked
      ? false
      : true;

    commonEntryStore.setPrivacyPolicy({
      checked: checked,
      type: this.typeobj.type,
    });
    this.privacyPolicyFlag = true;
  }

  public tooltipShow(type: string): void {
    if (type === APP_CONST.TOOL_TIP_CLOSE) {
      this.tooltipDisplay = false;
    }
    else {
      this.tooltipDisplay = true;
    }
  }

  public onSubmit(): void {
    this.loginProcessing = true;
    const registerObj: any = {};
    registerObj.type = this.typeobj.type;
    registerObj.password = passwordStore.getPassword;
    registerObj.confirmPassword = passwordStore.getConfirmPassword;
    registerObj.refSource = this.refSource;
    this.passValidation = {
      oldPassword: -1,
      password: registerObj.password.length,
      confirmPassword: registerObj.confirmPassword.length,
    };
    registerObj.passwordResetToken =
      this.$route &&
      this.$route.query.token &&
      (this.$route.query.token as string).split('"').join('');
    /* istanbul ignore if */
    if (
      (this.pathName === APP_CONST.APP_ROUTES.SIGNUP.name ||
        this.pathName == APP_CONST.APP_ROUTES.RESETPASSWORD.name) &&
      (commonEntryStore.getRememberMe === false ||
        commonEntryStore.getPrivacyPolicyChecked === false)
    ) {
      this.rememberMeFlag = commonEntryStore.getRememberMe;
      this.privacyPolicyFlag = commonEntryStore.getPrivacyPolicyChecked;
      this.loginProcessing = false;
      return;
    }
    /* istanbul ignore else */
    if (
      registerObj.password === registerObj.confirmPassword &&
      passwordStore.passwordValidityCheck
    ) {
      /* istanbul ignore else */
      if (
        registerObj.password.length !== 0 &&
        registerObj.confirmPassword.length !== 0 &&
        registerObj.passwordResetToken &&
        registerObj.passwordResetToken.length !== 0
      ) {
        this.strMessage = '';
        const registerRes: any = commonEntryStore.register(
          registerObj as RegisterObj
        );
        registerRes.then((resData: any) => {
          this.validateAfterRegister(resData);
        });
      }
      else if (
        registerObj.passwordResetToken &&
        registerObj.passwordResetToken.length === APP_CONST.ZERO
      ) {
        this.strMessage = this.getScreenText('ERROR_PASSWORD_TOKEN_LENGTH');
      }
      this.styleClass = APP_CONST.UKVISIBLE;
    }
  }

  async validateAfterRegister(resData: any) {
    if (resData.status == APP_CONST.RESPONSE_200) {
      const objLoginData: any = {};
      objLoginData.type = config.loginPassObj.type;
      objLoginData.password = passwordStore.getPassword;
      this.passValidation.password = objLoginData.password.length;
      objLoginData.email = this.email;
      /* istanbul ignore if */
      if (
        objLoginData.email.length !== APP_CONST.ZERO &&
        objLoginData.password.length !== APP_CONST.ZERO
      ) {
        const { loginWithRedirect } = getInstance();
        await StripeModule.createSetupIntent();
        loginWithRedirect({ targetUrl: this.redirect });
      }
    }
    else if (
      resData.data &&
      resData.status == APP_CONST.RESPONSE_400 &&
      (resData.data.name === APP_CONST.ERROR_SELECTED_ACCOUNT_ADMIN ||
        resData.data.name === APP_CONST.ERROR_SELECTED_PROGRAM_ADMIN ||
        resData.data.name === APP_CONST.ERROR_SELECTED_SESSION_ADMIN)
    ) {
      if (this.firstErrorForAdmin === true) {
        UIkit.notification({
          message: resData.data.value,
          status: 'danger',
          pos: 'top-center',
          timeout: 5000,
        });
        this.firstErrorForAdmin = false;
      }
      this.errorMessage = false;
      this.loginProcessing = false;
      return;
    }
    else if (
      resData.status === APP_CONST.RESPONSE_400 &&
      resData.data &&
      resData.data.name === APP_CONST.ERROR_PASSWORD_UPDATE
    ) {
      const route = APP_CONST.REGISTER_PAGE_TOKEN_EXPIRED;
      this.$router &&
        this.$router.push({
          path: route,
          name: 'Login',
          query: { link: 'expired' },
          params: { showBtn: 'show' },
        });
    }
    if (resData.status === 406) {
      UIkit.notification({
        message: resData.data.Message,
        status: 'danger',
        pos: 'top-center',
        timeout: 5000,
      });
    }
    else if (resData.status === 400) {
      this.errorMessage = true;
    }
  }

  public beforeMount(): void {
    const getUsernameCookie = APP_UTILITIES.getCookie(APP_CONST.USERNAME);
    const token: any = this.$route && this.$route.query.token;
    this.styleClass = APP_CONST.UKHIDDEN;
    this.pathName = (this.$route && this.$route.name) || '';
    this.firstErrorForAdmin = true;
    /* istanbul ignore else */
    if (token) {
      const validateAuthToken = commonEntryStore.getUsernameFromToken(token);
      validateAuthToken
        .then((response: any) => {
          this.validatePageRoute(response);
        })
        .catch((error) => {
          console.log('validateAuthToken error >> ', error);
        });
    }
    /* istanbul ignore else */
    if (getUsernameCookie) {
      document.cookie = APP_CONST.USERNAME + '=; Max-Age=-99999999;';
    }
    /* istanbul ignore else */
    if (this.$route && this.$route.query && !this.$route.query.token) {
      this.$router && this.$router.push(APP_CONST.APP_ROUTES.LOGIN);
    }
  }

  validatePageRoute(response: any) {
    /* istanbul ignore else */
    if (
      response.status == APP_CONST.RESPONSE_400 &&
      (response.data.name === APP_CONST.ERROR_SELECTED_ACCOUNT_ADMIN ||
        response.data.name === APP_CONST.ERROR_SELECTED_PROGRAM_ADMIN ||
        response.data.name === APP_CONST.ERROR_SELECTED_SESSION_ADMIN)
    ) {
      UIkit.notification({
        message: response.data.value,
        status: 'danger',
        pos: 'top-center',
        timeout: 5000,
      });
      return;
    }
    /* istanbul ignore else */
    if (response.status == APP_CONST.RESPONSE_404) {
      this.errorEmailNotFound = true;
      UIkit.notification({
        message: this.getScreenText('ERROR_EMAIL_NOTFOUND'),
        status: 'danger',
        pos: 'top-center',
        timeout: 5000,
      });
    }
    /* istanbul ignore else */
    if (
      response.status == APP_CONST.RESPONSE_406 &&
      response.data.Message ==
        'Whoops! Looks like we can\'t find that account. Please contact your program administrator.'
    ) {
      UIkit.notification({
        message: response.data.Message,
        status: 'danger',
        pos: 'top-center',
        timeout: 5000,
      });
      return;
    }
    /* istanbul ignore next */
    if (this.$router.currentRoute.path === APP_CONST.APP_ROUTES.SIGNUP.path) {
      this.checkRegisterPageRoute(response);
    }
    else if (
      this.$router.currentRoute.path === APP_CONST.APP_ROUTES.RESETPASSWORD.path
    ) {
      this.checkSetPasswordPageRoute(response);
    }
  }

  public checkSetPasswordPageRoute(res: any) {
    /* istanbul ignore else */
    if (res.status === APP_CONST.RESPONSE_200) {
      this.showSetPasswordPage = true;
    }
    /* istanbul ignore else */
    if (res.status === APP_CONST.RESPONSE_400) {
      this.showSetPasswordPage = false;
      this.$router && this.$router.push(APP_CONST.APP_ROUTES.LOGIN.path);
    }
  }

  public checkRegisterPageRoute(response: any) {
    if (response.status === APP_CONST.RESPONSE_200) {
      this.showSetPasswordPage = true;
    }
    else if (response.status === APP_CONST.RESPONSE_400) {
      this.showSetPasswordPage = false;
      this.$router && this.$router.push(APP_CONST.REGISTER_PAGE_TOKEN_EXPIRED);
    }
    /* istanbul ignore else */
    if (response.status === APP_CONST.RESPONSE_409) {
      this.showSetPasswordPage = false;
      const emailToken = response.data;
      const route =
        APP_CONST.REGISTER_PAGE_TOKEN_EXPIRED +
        APP_CONST.REGISTER_PAGE_IDENTIFIER +
        emailToken;
      this.$router &&
        this.$router.push({
          path: route,
          name: 'Login',
          query: { link: 'expired', identifier: emailToken },
          params: { showBtn: 'show' },
        });
    }
  }

  openTooltip() {
    const toolTipReference: any = document.getElementById(APP_CONST.TOOL_TIP);
    /* istanbul ignore else */
    if (
      toolTipReference &&
      (!toolTipReference.style.visibility ||
        toolTipReference.style.visibility === APP_CONST.HIDDEN)
    ) {
      toolTipReference.style.visibility = APP_CONST.VISIBLE;
    }
  }

  closeTooltip() {
    const toolTipReference: any = document.getElementById(APP_CONST.TOOL_TIP);
    toolTipReference.style.visibility = APP_CONST.HIDDEN;
  }

  openUrl() {
    window.open(APP_CONST.PRIVACY_POLICY, '_blank');
  }

  openTermsUrl() {
    window.open(APP_CONST.TERMS_URL, '_blank');
  }

  public errorShowing() {
    this.rememberMeFlag = false;
    this.privacyPolicyFlag = false;
  }
  callHover(hoverText: string, $event: any) {
    this.hovering = true;
    this.hoverText = hoverText;
    const boundBox = $event.target.getBoundingClientRect();
    const coordX = boundBox.left;
    const coordY = boundBox.top;
    this.hoverStyleObj = {
      top: (coordY + 40).toString() + 'px',
      left: (coordX + 80).toString() + 'px',
    };
  }
  callHoverOut() {
    this.hovering = false;
  }
}
